import "./loan-sections.css";

const WHY_POINTS = [
  "Lowest interest rates in the market",
  "Quick approval and disbursal",
  "Hassle-free documentation",
  "Expert guidance at every step",
  "100% transparency & no hidden charges",
];

export default function LoanWhyChoose() {
  return (
    <section className="loan-why">
      <div className="loan-why-inner">
        <div className="loan-why-copy">
          <p className="loan-eyebrow">WHY CHOOSE GPS FINVEST</p>
          <h2 className="loan-why-title">
            Why Choose GPS Finvest for Your <span>Loan</span>?
          </h2>
          <p className="loan-why-lead">
            We partner with leading banks and NBFCs to bring you the best loan
            offers that suit your needs.
          </p>
          <ul className="loan-why-list">
            {WHY_POINTS.map((point) => (
              <li key={point}>
                <span className="loan-why-check" aria-hidden="true">
                  <i className="fa-solid fa-check" />
                </span>
                {point}
              </li>
            ))}
          </ul>
        </div>

        <div className="loan-why-visual">
          <img
            src="/images/loan-journey-phone.png"
            alt="Loan application journey on mobile"
            className="loan-why-img"
          />
        </div>
      </div>
    </section>
  );
}
